import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllPermissions = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/permissions',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updatePermission = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/permissions/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const savePermission = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/permissions',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deletePermission = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/permissions/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllPermissions,
  savePermission,
  updatePermission,
  deletePermission,
}
